var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MembreRelation } from './MembreRelation.class';
import { blockContactAsync, unblockContactAsync } from 'membre/store/actions';
import { dispatch } from 'store/store';
/**
 * Chaque objet est un lien unissant deux membres
 */
export class Blocage extends MembreRelation {
    /**
     * Constructeur de l'objet Blocage
     * @param contact contient les données de l'objet
     */
    constructor(bloqueObject) {
        if (bloqueObject) {
            const { idBlocage, bloqueur, bloque, dateBlocage } = bloqueObject;
            super({
                idRelation: idBlocage,
                idExpediteur: bloqueur,
                idRecepteur: bloque,
            });
            this.dateBlocage = dateBlocage;
        }
    }
    /**
     * Débloque un membre
     */
    remove() {
        return __awaiter(this, void 0, void 0, function* () {
            dispatch(unblockContactAsync(this.idRecepteur));
        });
    }
    /**
     * Bloque un membre
     * @param membre Membre à bloquer
     */
    static add(membre) {
        dispatch(blockContactAsync(membre.infoPublic.idMembre));
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmxvY2FnZS5jbGFzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkJsb2NhZ2UuY2xhc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLHdCQUF3QixDQUFDO0FBQ3hELE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxtQkFBbUIsRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBQzlFLE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxhQUFhLENBQUM7QUFHdkM7O0dBRUc7QUFDSCxNQUFNLE9BQU8sT0FBUSxTQUFRLGNBQWM7SUFxQjFDOzs7T0FHRztJQUNILFlBQW1CLFlBQStCO1FBQ2pELElBQUksWUFBWSxFQUFFO1lBQ2pCLE1BQU0sRUFBRSxTQUFTLEVBQUUsUUFBUSxFQUFFLE1BQU0sRUFBRSxXQUFXLEVBQUUsR0FBRyxZQUFZLENBQUM7WUFFbEUsS0FBSyxDQUFDO2dCQUNMLFVBQVUsRUFBRSxTQUFTO2dCQUNyQixZQUFZLEVBQUUsUUFBUTtnQkFDdEIsV0FBVyxFQUFFLE1BQU07YUFDbkIsQ0FBQyxDQUFDO1lBRUgsSUFBSSxDQUFDLFdBQVcsR0FBRyxXQUFXLENBQUM7U0FDL0I7SUFDRixDQUFDO0lBRUQ7O09BRUc7SUFDVSxNQUFNOztZQUNsQixRQUFRLENBQUMsbUJBQW1CLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUM7UUFDakQsQ0FBQztLQUFBO0lBRUQ7OztPQUdHO0lBQ0ksTUFBTSxDQUFDLEdBQUcsQ0FBQyxNQUFjO1FBQy9CLFFBQVEsQ0FBQyxpQkFBaUIsQ0FBQyxNQUFNLENBQUMsVUFBVSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUM7SUFDekQsQ0FBQztDQUNEIn0=